import React, { useState } from 'react';

//comps
import CatalogOrderModal from './CatalogOrderModal';

import { PHOTO_BASE_URL } from 'utils/helpers';

const CatalogoItem = ({ product, onView }) => {
	const points = product.points?.toLocaleString('es-ES');
	const [showModalCanjear, setShowModalCanjear] = useState(false);
	const toggleModalCanjear = () => setShowModalCanjear(!showModalCanjear);

	const firstPhoto = product.photos?.split(',')[0]?.trim();

	return (
		<div className="card">
			<img
				src={firstPhoto ? `${PHOTO_BASE_URL}${firstPhoto}` : 'https://placehold.co/300x320/FFFFFF/000000'}
				alt={product.name}
				onClick={() => onView(product)}
			/>
			<h2>{product.name}</h2>
			<p className="points-text">{points} puntos</p>

			{product.stock > 0 ? (
				<div className="btn" onClick={() => setShowModalCanjear(true)}>
					CANJEAR PUNTOS
				</div>
			) : (
				<div className="btn out-stock">
					AGOTADO
				</div>
			)}

			<div className="link" onClick={() => onView(product)}>
				Ver producto
			</div>

			{showModalCanjear && (
				<CatalogOrderModal toggle={toggleModalCanjear} product={product} />
			)}
		</div>
	);
};

export default CatalogoItem;
